/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opening_HoursInputs */

const en_opening_hours = /** @type {(inputs: Opening_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon – Sun, 10:00 – 19:00`)
};

const th_opening_hours = /** @type {(inputs: Opening_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จันทร์ – อาทิตย์ 10.00 – 19.00 น.`)
};

const ja_opening_hours = /** @type {(inputs: Opening_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月〜日 10:00〜19:00`)
};

const fr_opening_hours = /** @type {(inputs: Opening_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lun – Dim, 10h00 – 19h00`)
};

const es_opening_hours = /** @type {(inputs: Opening_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lun – Dom, 10:00 – 19:00`)
};

const ru_opening_hours = /** @type {(inputs: Opening_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пн – Вс, 10:00 – 19:00`)
};

const zh_opening_hours = /** @type {(inputs: Opening_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`周一至周日 10:00 – 19:00`)
};

const vi_opening_hours = /** @type {(inputs: Opening_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thứ Hai – Chủ Nhật, 10:00 – 19:00`)
};

/**
* | output |
* | --- |
* | "Mon – Sun, 10:00 – 19:00" |
*
* @param {Opening_HoursInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const opening_hours = /** @type {((inputs?: Opening_HoursInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opening_HoursInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_opening_hours(inputs)
	if (locale === "ja") return ja_opening_hours(inputs)
	if (locale === "fr") return fr_opening_hours(inputs)
	if (locale === "es") return es_opening_hours(inputs)
	if (locale === "ru") return ru_opening_hours(inputs)
	if (locale === "zh") return zh_opening_hours(inputs)
	if (locale === "vi") return vi_opening_hours(inputs)
	return en_opening_hours(inputs)
});